export default __webpack_public_path__ + "static/media/april1st.229f3491.png";